import { callBackendApi } from "src/components/service/axios";
import { CurrentSystemResourceAccess } from "../models/information-asset-accesses";

export const fetchInformationAssetsAccesses = async (): Promise<CurrentSystemResourceAccess[]> => {
  return await callBackendApi("get", "/bff/information-accesses", null, null, true, {
    timeout: 40000,
  });
};
